var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    staticClass: "Modal",
    attrs: {
      "name": _vm.getTransition
    },
    on: {
      ":after-leave": _vm.animationFinished
    }
  }, [_vm.showModal ? _c('div', {
    staticClass: "Modal-mask",
    class: 'Modal-mask--' + _vm.type,
    attrs: {
      "id": "js-mask"
    },
    on: {
      "click": _vm.clickFromMask,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.clickOnMask.apply(null, arguments);
      }
    }
  }, [_c('div', {
    class: _vm.getModalContainerClass
  }, [_c('header-modal', {
    class: 'Modal-header--' + _vm.getSize,
    attrs: {
      "title": _vm.headerTitle
    },
    on: {
      "hideModal": _vm.hideModal
    }
  }), _c('div', {
    class: _vm.getModalContentClass,
    style: _vm.maxContentHeight && !_vm.isPhoneBreakpoint ? {
      maxHeight: _vm.maxContentHeight
    } : {}
  }, [_vm._t("default")], 2)], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }